const doc = [({"da":({"js":({"components":({"schools":({"current_schools":({"current_schools":"Nuværende skoler"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;